import parsePhoneNumber from 'libphonenumber-js';

/**
 * Format the phone number to the national format
 * If the phone number is not valid, return the original phone number
 * @param phoneNumber
 * @return the formatted phone number
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const formattedPhoneNumber = parsePhoneNumber(phoneNumber, 'CA');
  return formattedPhoneNumber
    ? formattedPhoneNumber.formatNational()
    : phoneNumber;
};
